// src/utils/calendar.js

export const formatDateForCal = (date) => {
  const d = new Date(date);
  return d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
};

export const addToGoogleCalendar = (title, agreementID, deadline) => {
  const start = deadline ? formatDateForCal(deadline) : formatDateForCal(new Date());
  // For all-day event, end = start + 1 hour
  const endDate = new Date(deadline || new Date());
  endDate.setHours(endDate.getHours() + 1);
  const end = formatDateForCal(endDate);
  const details = `TuttoClaro Agreement ID: ${agreementID}\n\nThis agreement was confirmed on TuttoClaro.`;
  const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${start}/${end}&details=${encodeURIComponent(details)}`;
  window.open(url, '_blank');
};

export const downloadICS = (title, agreementID, deadline) => {
  const start = deadline ? formatDateForCal(deadline) : formatDateForCal(new Date());
  const endDate = new Date(deadline || new Date());
  endDate.setHours(endDate.getHours() + 1);
  const end = formatDateForCal(endDate);
  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//TuttoClaro//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `SUMMARY:${title}`,
    `DTSTART:${start}`,
    `DTEND:${end}`,
    `DESCRIPTION:TuttoClaro Agreement ID: ${agreementID}`,
    `UID:${agreementID}@tuttoclaro.com`,
    'STATUS:CONFIRMED',
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${title.replace(/[^a-zA-Z0-9]/g, '_')}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const addToOutlookWeb = (title, agreementID, deadline) => {
  const start = deadline ? new Date(deadline).toISOString() : new Date().toISOString();
  const endDate = new Date(deadline || new Date());
  endDate.setHours(endDate.getHours() + 1);
  const end = endDate.toISOString();
  const body = `TuttoClaro Agreement ID: ${agreementID}`;
  const url = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(title)}&startdt=${start}&enddt=${end}&body=${encodeURIComponent(body)}`;
  window.open(url, '_blank');
};
